<template >
    <div class="p-grid p-fluid">
        
        <div class="p-lg-6 p-col-12 dashboard" >
        <div :class="estiloExtrato" class="summary-box " @click="alternarPaginas($event,'extrato')" style="cursor:pointer">
            <Card class=" card" >
                <template slot="content">
                    <p class="summary-box-title">Extrato</p>
                    <p>de Licença Prêmio</p>
                    <img src="../../../public/assets/layout/images/tmp/graph-messages.svg" alt="sapphire" class="summary-box-graph">
                    <i class="pi pi-id-card summary-box-icon ico"></i  >
                </template>
            </Card>
        </div>
        </div>
        <div class="p-lg-6 p-col-12 dashboard" >
        <div :class="estiloAgendamento" class="summary-box " @click="alternarPaginas($event,'agendamento')" style="cursor:pointer">
            <Card class=" card" >
                <template slot="content">
                    <p class="summary-box-title">Agendamento</p>
                    <p>de Licença Prêmio</p>
                    
                    <img data-v-b29879e6="" src="../../../public/assets/layout/images/tmp/graph-messages.svg" alt="sapphire" class="summary-box-graph">
                    <i class="pi pi-calendar summary-box-icon ico"></i>
                </template>
            </Card>
        </div>        
        </div>
        
        
        <extratoLicencaPremioServidor  v-if="this.mostrarExtrato" />        
        <agendamentoLicencaPremioServidor v-if="this.mostrarAgendamento" />
            
        <div class="p-grid p-col-6" align="right" v-if="this.mostrarAgendamento">
            <div class="p-col-12 p-md-4">
                <!--<router-link :to="{name: 'licencaPremioServidor'}">-->
                    <Button label="Voltar" icon="pi pi-undo" class="p-button-secondary" @click="alternarPaginas($event,'extrato')"></Button>
                <!--</router-link>-->
            </div>
        </div>
    
    </div>
</template>
<script>
import agendamentoLicencaPremioServidor from '@/paginas/licencapremio/agendamentoLicencaPremioServidor.vue'
import extratoLicencaPremioServidor from '@/paginas/licencapremio/extratoLicencaPremioServidor.vue'
// import { baseApiUrl } from '@/config/global'


export default {
    name: 'licencaPremioServidor',
    components: {  agendamentoLicencaPremioServidor, extratoLicencaPremioServidor },    
    data: function(){
        return{
            modoEdicao: 'adicionar',
            mostrarExtrato:false,
            mostrarAgendamento:false,
            selectedTipoGozo: {name: '10 dias', code: '10'},
            agendamentos : null,
           
        }
    },
    methods:{
        
        alternarPaginas(e,click){
          
            this.mostrarExtrato = (click=='extrato') ? true : false;
            this.mostrarAgendamento = (click=='agendamento') ? true : false;
        }
    },
    computed:{
        estiloExtrato(){
            return{
                'summary-box-inativo':this.mostrarAgendamento,
                'summary-box-azul':this.mostrarExtrato,
            }
        },
        estiloAgendamento(){
            return{
                'summary-box-inativo':this.mostrarExtrato,
                'summary-box-amarelo':this.mostrarAgendamento,
            }
        }
    },
    mounted(){
        this.alternarPaginas(null,'extrato')
        
    }
}
</script>
<style scoped>
    .dashboard > div {
        padding: 1em;
    }
    .dashboard .dashboard-grid {
        margin-left: 0;
        margin-right: 0;
        margin-top: 0;
        padding: 0;
    }
    .dashboard .card {
        height: 100%;
        margin-bottom: 0;
    }
    .dashboard .summary-box {
        position: relative;
    }
    .dashboard .summary-box .card {
        min-height: 100px;
    }
    .dashboard .summary-box .summary-box-title {
        font-size: 2em;
        margin: 0;
        color: #ffffff;
    }
    .dashboard .summary-box p {
        margin: 0.25em 0;
        color: #ffffff;
    }
    .dashboard .summary-box .summary-box-icon {
        position: absolute;
        font-size: 5em;
        right: 24px;
        top: 32px;
    }
    .dashboard .summary-box .summary-box-graph {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    
    .dashboard .summary-box.summary-box-inativo .card {
        border-top: 4px solid grey;
        background-color: #c2c2c2;

    }
    .dashboard .summary-box.summary-box-azul .card {
        border-top: 4px solid #0097a7;
        background-color: #00bcd4;
    }
    .dashboard .summary-box.summary-box-azul .ico {
        color: #0097a7;
    }
    .dashboard .summary-box.summary-box-rosa .card {
        border-top: 4px solid #ad1457;
        background-color: #e91e63;
    }
    .dashboard .summary-box.summary-box-rosa .ico {
        color: #ad1457;
    }
    .dashboard .summary-box.summary-box-amarelo .card {
        border-top: 4px solid #f47b08;
        background-color: #ffb300;
    }
    .dashboard .summary-box.summary-box-amarelo .ico {
        color: #f47b08;
    }
    .dashboard .summary-box.summary-box-cinza .card {
        border-top: 4px solid #455a64;
        background-color: #607d8b;
    }
    .dashboard .summary-box.summary-box-cinza .ico {
        color: #455a64;
    }

    /* STATUS DE VALIDAÇÃO DA CHEFIA*/
    .customer-badge {
        border-radius: 2px;
        padding: .25em .5em;
        text-transform: uppercase;
        font-weight: 700;
        font-size: 12px;
        letter-spacing: .3px;
    }
        .status-Aceito {
            background-color: #C8E6C9;
            color: #256029;
        }

        .status-Pendente {
            background-color: #FFCDD2;
            color: #C63737;
        }

        .status-negotiation {
            background-color: #FEEDAF;
            color: #8A5340;
        }

        .status-new {
            background-color: #B3E5FC;
            color: #23547B;
        }

        .status-renewal {
            background-color: #ECCFFF;
            color: #694382;
        }

        .status-proposal {
            background-color: #FFD8B2;
            color: #805B36;
        }
    

        /* status */
        .status-Usufruido {
            font-weight: bold;
            color: #23547B;
        }
        .status-Agendado {
            font-weight: bold;
            color: #256029;
        }
        .status-Aguardando {
            font-weight: bold;
            color: yellowgreen;
        }
</style>